'use client';
function toInt(value) {
  return value ? parseInt(value, 10) : 0;
}

export { toInt };
//# sourceMappingURL=to-int.mjs.map
